$(document).ready(function() {
  $('#estimate-your-cost').change(function() {
    typeOfPodcast = $("#type-of-podcast").val()
    productionQuality = $("#production-quality").val()
    episodeLengthMins = $("#episode-length").val()
    episodeLength = 1
    if (episodeLengthMins == '30') { episodeLength = 1.5 }
    if (episodeLengthMins == '45') { episodeLength = 1.75 }
    if (episodeLengthMins == '60') { episodeLength = 2 }
    if (episodeLengthMins == '75') { episodeLength = 2.25 }
    if (episodeLengthMins == '90') { episodeLength = 2.5 }
    $('#episode-lenght-title').empty().append(episodeLengthMins)
    btn1 = $('#btnradio1:checked').val()
    btn2 = $('#btnradio2:checked').val()
    btn3 = $('#btnradio3:checked').val()
    btn4 = $('#btnradio4:checked').val()
    numOfEpisodes = 6
    numE = 1; 
    if (btn2) { numOfEpisodes = 8; numE = 1.25; }
    if (btn3) { numOfEpisodes = 10; numE = 1.5; }
    if (btn4) { numOfEpisodes = 12; numE = 1.75; }

    editingAndPostProduction = $('#editing-and-post-production').val()
    topicAndTargetAudience = $('#topic').val()


 //   console.log(typeOfPodcast);
 //   console.log(productionQuality);
 //   console.log("mins: ", episodeLengthMins)
 //   console.log(episodeLength);
 //   console.log(numOfEpisodes);
 //   console.log(numE);
 //   console.log(editingAndPostProduction)
 //   console.log(topicAndTargetAudience)
    
    price = 4500 * typeOfPodcast * productionQuality * episodeLength * numE * editingAndPostProduction * topicAndTargetAudience
//    console.log(price)
function formatMoney(number) {
  price = number.toLocaleString('en-US', { style: 'currency', currency: 'USD' });

return price.replace(".00", "");
}


    $('#estimate-cost-price-value').empty().append(formatMoney(price));
  })
})
